// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_35g6P","visuallyhidden":"_1GBuv","hide-text":"_-zlRF","center":"_2LIxc","noprint":"_2cDro","front":"_29qdn","subheader":"NTQbD","tagTitle":"DUtUO","articleCards":"_2PVad","imageWrapper":"_2NRra","plussIndicator":"_2yDdq","articleCard":"_2arR4","fullWidthMobile":"_3eiGu","showMore":"_2daJT","fullWidthDesktop":"_4yfHE"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/collection/default.scss
 ** module id = 979
 ** module chunks = 2
 **/